import api from "./axios";

class CertificationsService {
  async getAll() {
    try {
      const response = await api.get(`/certifications`);
      return response.data;
    } catch (error) {
      console.error("Error fetching certifications:", error);
      throw error;
    }
  }

  async getOne(id) {
    try {
      const response = await api.get(`/certifications/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching certification with ID ${id}:`, error);
      throw error;
    }
  }

  async create(certificationData, token) {
    try {
      const response = await api.post(`/certifications`, certificationData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating certification:", error);
      throw error;
    }
  }

  async update(id, certificationData, token) {
    try {
      const response = await api.patch(
        `/certifications/${id}`,
        certificationData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating certification with ID ${id}:`, error);
      throw error;
    }
  }

  async delete(id, token) {
    try {
      const response = await api.delete(`/certifications/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting certification with ID ${id}:`, error);
      throw error;
    }
  }
}

export default new CertificationsService();
